import { render, staticRenderFns } from "./JourneyDetailMemberEdit.vue?vue&type=template&id=066b867c&scoped=true"
import script from "./JourneyDetailMemberEdit.vue?vue&type=script&lang=js"
export * from "./JourneyDetailMemberEdit.vue?vue&type=script&lang=js"
import style0 from "./JourneyDetailMemberEdit.vue?vue&type=style&index=0&id=066b867c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b867c",
  null
  
)

export default component.exports